import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import localFont from 'next/font/local'

import { PageTransition } from '@/components/generals/page-transition'

const satoshi = localFont({
    src: [
        { path: '../../public/fonts/satoshi-400.woff2', weight: '400', style: 'normal' },
        { path: '../../public/fonts/satoshi-500.woff2', weight: '500', style: 'normal' },
        { path: '../../public/fonts/satoshi-700.woff2', weight: '700', style: 'normal' }
    ],
    display: 'swap',
    fallback: ['ui-sans-serif', 'system-ui', 'sans-serif']
})

const manrope = localFont({
    src: [
        { path: '../../public/fonts/manrope-500.woff2', weight: '500', style: 'normal' },
        { path: '../../public/fonts/manrope-700.woff2', weight: '700', style: 'normal' }
    ],
    display: 'swap',
    fallback: ['ui-sans-serif', 'system-ui', 'sans-serif']
})

const inter = localFont({
    src: [
        { path: '../../public/fonts/inter-400.woff2', weight: '400', style: 'normal' },
        { path: '../../public/fonts/inter-500.woff2', weight: '500', style: 'normal' },
        { path: '../../public/fonts/inter-600.woff2', weight: '600', style: 'normal' }
    ],
    display: 'swap',
    fallback: ['ui-sans-serif', 'system-ui', 'sans-serif']
})

const fontVariables = `:root{--font-app-sans:${satoshi.style.fontFamily};--font-app-heading:${manrope.style.fontFamily};--font-app-body:${inter.style.fontFamily};--font-app-mono:ui-monospace,SFMono-Regular,Menlo,monospace}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <meta name='viewport' content='width=device-width, initial-scale=1' />
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <PageTransition>
                <Component {...pageProps} />
            </PageTransition>
        </div>
    )
}

export default App
